"use client";

import { c as _c } from "react/compiler-runtime";
import cn from "classnames";
import { useState } from "react";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";
import { FAQ_ITEMS } from "../../../constants/faq";
export function FaqList() {
  const $ = _c(7);
  const [openIndex, setOpenIndex] = useState(null);
  let t0;
  if ($[0] !== openIndex) {
    t0 = index => {
      setOpenIndex(openIndex === index ? null : index);
    };
    $[0] = openIndex;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const toggleQuestion = t0;
  let t1;
  if ($[2] !== openIndex || $[3] !== toggleQuestion) {
    t1 = FAQ_ITEMS.map((item, index_0) => <div key={index_0} className="border border-gray-200 dark:border-slate-750 rounded-lg overflow-hidden bg-white dark:bg-slate-850 transition-colors duration-200"><button onClick={() => toggleQuestion(index_0)} className="w-full flex justify-between items-center p-4 text-left hover:bg-gray-50 dark:hover:bg-slate-750 transition-colors duration-200"><span className="font-medium text-lg text-gray-900 dark:text-gray-100">{item.question}</span>{openIndex === index_0 ? <IoChevronUp className="w-6 h-6 text-brand-500" /> : <IoChevronDown className="w-6 h-6 text-gray-400" />}</button><div className={cn("transition-all duration-300 ease-in-out overflow-hidden", openIndex === index_0 ? "max-h-96 opacity-100" : "max-h-0 opacity-0")}><div className="p-4 text-gray-600 dark:text-gray-300 leading-relaxed border-t border-gray-200 dark:border-slate-750/50">{item.answer}</div></div></div>);
    $[2] = openIndex;
    $[3] = toggleQuestion;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <div className="space-y-4">{t1}</div>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}